import { Injectable } from '@angular/core';
import { EndpointConfig } from '../common/EndpointConfig';
import { HttpClient } from '@angular/common/http';
import { DefaultService } from '../common/default.service';

@Injectable({
  providedIn: 'root'
})
export class GReportingService {

  private _ep: EndpointConfig;
  constructor(private http: HttpClient, private _defaultService: DefaultService) {
    this._ep = new EndpointConfig('');
  }


  public GetInventoryFlowReportAsync(itemId: number, warehouseId: number) {
    return this.http.get(`${this._ep.getControllerUrl('GReporting', 'GetInventoryFlowReportAsync')}/${itemId}/${warehouseId}`);
  }

  public GetItemStockReportAsync(warehouseId: number) {
    return this.http.get(`${this._ep.getControllerUrl('GReporting', 'GetItemStockReportAsync')}/${warehouseId}`);
  }

  public GetItemStockReportExportAsync(fromDate: Date | string, toDate: Date | string) {
    const f = new Date(fromDate).toISOString().split('T')[0]; // yyyy-MM-dd
    const t = new Date(toDate).toISOString().split('T')[0];
    return this.http.get(
      `${this._ep.getControllerUrl('GReporting', 'GetItemStockReportExportAsync')}/${encodeURIComponent(f)}/${encodeURIComponent(t)}`
    );
  }

  public GetWarehouseStockReportAsync(warehouseId: number) {
    return this.http.get(`${this._ep.getControllerUrl('GReporting', 'GetWarehouseStockReportAsync')}/${warehouseId}`);
  }

   public GetAggingReportAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GReporting', 'GetAggingReportAsync')}`);
  }

  public GetGSaleReportAsync(id: number, fromDate: string, toDate: string) {
    return this.http.get(`${this._ep.getControllerUrl('GReporting', 'GetGSaleReportAsync')}/${id}/${fromDate}/${toDate}`);
  }

   public GetVmhReportAsync(id: number, fromDate: string, toDate: string) {
    return this.http.get(`${this._ep.getControllerUrl('GReporting', 'GetVmhReportAsync')}/${id}/${fromDate}/${toDate}`);
  }

  public GetAllInvoiceReportAsync(id: number, fromDate: string, toDate: string) {
    return this.http.get(`${this._ep.getControllerUrl('GReporting', 'GetAllInvoiceReportAsync')}/${id}/${fromDate}/${toDate}`);
  }

  public GetAllInvoiceReportExportAsync(obj: any) {
    return this.http.post(`${this._ep.getControllerUrl('GReporting', 'GetAllInvoiceReportExportAsync')}`, obj);
  }
}
